import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MailWarning } from "lucide-react";
import { toast } from "sonner";

export default function VerifyRequiredDialog() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("ss:verify-required", handler);
    return () => window.removeEventListener("ss:verify-required", handler);
  }, []);

  const resend = async () => {
    try {
      await api.post("/auth/resend-otp");
      toast.success("Verification email sent — check your inbox.");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Could not resend email"); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="rounded-2xl" data-testid="verify-required-dialog">
        <DialogHeader>
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-2xl bg-amber-100 text-amber-700"><MailWarning className="h-5 w-5" /></div>
          <DialogTitle>Verify your email to continue</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-500">Please verify your email address to continue. Check your inbox for your verification code.</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" className="rounded-full" data-testid="verify-required-resend" onClick={resend}>Resend verification email</Button>
          {user && <Button className="rounded-full bg-primary font-semibold" data-testid="verify-required-enter" onClick={() => { setOpen(false); navigate("/verify"); }}>Enter code</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
